export var POST_MESSAGE_TYPES = {
  GUESTY_TOKENIZATION_FORM_READY: 'GUESTY_TOKENIZATION_FORM_READY',
  GUESTY_TOKENIZATION_FORM_RESIZE: 'GUESTY_TOKENIZATION_FORM_RESIZE',
  GUESTY_TOKENIZATION_FORM_STATUS_CHANGE: 'GUESTY_TOKENIZATION_FORM_STATUS_CHANGE',
  GUESTY_TOKENIZATION_FORM_VALIDATE: 'GUESTY_TOKENIZATION_FORM_VALIDATE',
  GUESTY_TOKENIZATION_FORM_SUBMIT: 'GUESTY_TOKENIZATION_FORM_SUBMIT',
  GUESTY_TOKENIZATION_FORM_PROPS: 'GUESTY_TOKENIZATION_FORM_PROPS',
  GUESTY_TOKENIZATION_SUCCESS: 'GUESTY_TOKENIZATION_SUCCESS',
  GUESTY_TOKENIZATION_ERROR: 'GUESTY_TOKENIZATION_ERROR'
};
export var IFRAME_ID = 'guesty-tokenization-iframe';